import { DeprecatedTimezoneMap, TimezoneData as TimezoneStrings } from '@modernloop/shared/datetime';

export const getTimezoneDisplayName = (timezone: string): string => {
  const finalTimezone = DeprecatedTimezoneMap[timezone] ? DeprecatedTimezoneMap[timezone] : timezone;
  return TimezoneStrings.find((tz) => tz.value === finalTimezone)?.label || timezone;
};
